/**
 *
 */

var Slideshow = (function($) {
  function initSlideshow() {
    $.supersized({
      // Functionality
      slideshow: 1, // Slideshow on/off
      autoplay: 1, // Slideshow starts playing automatically
      start_slide: 0, // Start slide (0 is random)
      stop_loop: 0, // Pauses slideshow on last slide
      random: 1, // Randomize slide order (Ignores start slide)
      slide_interval: 250, // Length between transitions
      transition: 0, // 0-None, 1-Fade, 2-Slide Top, 3-Slide Right, 4-Slide Bottom, 5-Slide Left, 6-Carousel Right, 7-Carousel Left
      transition_speed: 250, // Speed of transition
      new_window: 1, // Image links open in new window/tab
      pause_hover: 0, // Pause slideshow on hover
      keyboard_nav: 1, // Keyboard navigation on/off
      performance: 1, // 0-Normal, 1-Hybrid speed/quality, 2-Optimizes image quality, 3-Optimizes transition speed // (Only works for Firefox/IE, not Webkit)
      image_protect: 1, // Disables image dragging and right click with Javascript

      // Size & Position
      min_width: 0, // Min width allowed (in pixels)
      min_height: 0, // Min height allowed (in pixels)
      vertical_center: 1, // Vertically center background
      horizontal_center: 1, // Horizontally center background
      fit_always: 1, // Image will never exceed browser width or height (Ignores min. dimensions)
      fit_portrait: 1, // Portrait images will not exceed browser height
      fit_landscape: 1, // Landscape images will not exceed browser width

      // Components
      slide_links: "blank", // Individual links for each slide (Options: false, 'num', 'name', 'blank')
      thumb_links: 1, // Individual thumb links for each slide
      thumbnail_navigation: 0, // Thumbnail navigation
      slides: [
        // Slideshow Images
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma2.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma3.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma4.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma5.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma6.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma7.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma8.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma9.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma11.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma12.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma13.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma14.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma15.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma16.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma17.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma18.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma19.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma20.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma21.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma22.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma23.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma24.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma25.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma26.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma27.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma28.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma29.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma30.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma31.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma32.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma33.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma34.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma35.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma36.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma37.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma38.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma39.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma40.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma41.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma42.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma43.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma44.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma45.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma46.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma47.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma48.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma49.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma50.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma51.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma52.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma53.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma54.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma55.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma56.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma57.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma58.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma59.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma60.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma61.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma62.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma63.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma64.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma65.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma66.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma67.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma68.png" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma69.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma70.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma71.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma72.jpg" },
        { image: "/wp-content/themes/lacomastudio/inc/img/lacoma73.jpg" }
      ],
      // Theme Options
      progress_bar: 1, // Timer for each slide
      mouse_scrub: 0
    });

    // do something
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".home").length) {
      return;
    }

    initSlideshow();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Slideshow.init);
